import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Table } from "antd";
import Card from "components/card";
import PopupButton from "components/button/PopupButton";
import CrudOption from "components/dropdown/crudoption";
import { handleTableChange } from "../../../../utils";
import {
    getAssetList,
    doAssetDelete,
    doAssetReset,
} from "../../../../redux/asset/assetState";
import SearchFilter from "components/search/SearchFilter";
import {
    getAssetTypeList,
    getAssetStatusList,
} from "../../../../redux/optionlist/optionlistState";
import AssetManagementForm from "./AssetManagementForm";
import { MODULE_ASSET_MANAGEMENT } from "variables/modules";

const AssetManagementTable = ({ }) => {
	const dispatch = useDispatch();

	const recordList = useSelector((state) => state.asset.assetList?.items);
    const pagination = useSelector((state) => state.asset.assetList?.pagination);
	const filters = useSelector((state) => state.asset.assetList?.filters);
	const equipmentTypeList = useSelector((state) => state.optionlist.assetTypeList?.items);
	const assetStatusList = useSelector((state) => state.optionlist.assetStatusList?.items);

	const doSearch = (filters) => dispatch(getAssetList(filters));
    const doDelete = (recordId) => dispatch(doAssetDelete(recordId));
    const doRecordReset = () => dispatch(doAssetReset());

	const columns = [
			{
				title: "Asset No.",
				dataIndex: "asset_number",
				key: "asset_number",
				width: "5%",
				render: (asset_number) => <span>{asset_number}</span>,
			},
			{
				title: "Hyvid Tag",
				dataIndex: "ast_hyvid_tag",
				key: "ast_hyvid_tag",
				width: "15%",
				render: (ast_hyvid_tag) => <span>{ast_hyvid_tag}</span>,
			},
			{
				title: "Location",
				dataIndex: "location_name",
				key: "location_name",
				width: "12%",
				render: (location_name) => <span>{location_name}</span>,
			},
			{
			title: (
				<>
					<div>Status /</div>
					<div>Condition</div>
				</>
			),
			key: "ast_status_id",
			width: "10",
			dataIndex: "ast_status_id",
			filters: assetStatusList?.map((status) => ({
				text: status.label,
				value: status.value,
			})) || [],
			render: (_, record) => (
				<>
					<div>{record?.asset_status_name || "-"}</div>
					<div>{record?.asset_condition_name || "-"}</div>
				</>
			),

			},
			{
				title: "Equipment Type",
				dataIndex: "equipment_type_name",
				key: "ast_equipment_type_id",
				width: "10%",
				filters: equipmentTypeList?.map((type) => ({
					text: type.label,
					value: type.value,
				})) || [],
				render: (equipment_type_name) => <span>{equipment_type_name}</span>,
			},
			{
				title: "Brand",
				dataIndex: "ast_make",
				key: "make",
				width: "10%",
				render: (ast_make) => <span>{ast_make}</span>,
			},
			{
				title: "Model",
				dataIndex: "ast_model",
				key: "ast_model",
				width: "10%",
				render: (ast_model) => <span>{ast_model}</span>,
			},
			{
				title: "Individual SN",
				dataIndex: "ast_individual_serial_number",
				key: "ast_individual_serial_number",
				width: "15%",
				render: (ast_individual_serial_number) => (
					<span>{ast_individual_serial_number}</span>
				),
			},
			{
				title: "Bundled SN",
				dataIndex: "ast_bundled_serial_number",
				key: "bundled_serial_number",
				width: "15%",
				render: (ast_bundled_serial_number) => (
					<span>{ast_bundled_serial_number}</span>
				),
			},
			{
				title: (
					<PopupButton id="add_asset" title="Add Asset" label="Add" btnClass="btn-small" action="add" moduleId={MODULE_ASSET_MANAGEMENT}>
						<AssetManagementForm recordId={0} mode="edit" />
					</PopupButton>
				),
				dataIndex: "ast_id",
				key: "ast_id",
				width: "12%",
				render: (_, record) => {
					return (
						<CrudOption
							recordId={record.ast_id}
							baseRoute="/console/assets-management"
							editMode="modal"
							deleteHandler={doDelete}
							title="Edit Asset"
							viewMode="page"
							editHandler={(recordId, doRecordReset ) => (
								<AssetManagementForm
									recordId={recordId}
									onCancel={doRecordReset}
									mode="edit"
								/>
							)}
							closeHandler={doRecordReset}
						/>
					);
				}
			},
	];

	useEffect(() => {
		dispatch(
			getAssetList({
				paginate: pagination?.per_page,
			})
		);

		dispatch(getAssetTypeList());
		dispatch(getAssetStatusList());
	}, [dispatch, pagination?.per_page]);

	return (
		<Card extra={"w-full h-full p-4"}>
			<div className="py-2">
				{/* <SearchFilter
					placeholder="Search by Asset Type or Status"
					searchHandler={doSearch}
					filters={filters}
					pagination={pagination}
				/> */}
			</div>
			<div className="h-full overflow-x-scroll xl:overflow-x-hidden">
				<Table
					dataSource={recordList}
					columns={columns}
					rowKey={(record) => record.ast_id}
					pagination={{
						...pagination,
						showTotal: (total, range) =>
							`${range[0]} - ${range[1]} of ${total} records`,
					}}
					onChange={handleTableChange(doSearch, filters)}
				/>
			</div>
		</Card>
	);
};

export default (AssetManagementTable);